import React from 'react';
import PropTypes from 'prop-types';
import { FormattedTag, RouteLink } from 'core/components';
import { getBackgroundStyles } from 'helpers/images';
import { withPixelRatio } from 'hocs/with-pixel-ratio';

export const GameTagsItemUI = ({
  tagName, imageUrl, pixelRatio
}) => {
  const backgroundStyles = getBackgroundStyles(imageUrl, pixelRatio);

  return (
    <RouteLink
      className="game-tags-item position-relative d-flex align-items-center"
      key={tagName}
      to={`/game-tags/${tagName}`}
    >
      <div
        className="game-tags-item-image position-absolute"
        style={backgroundStyles}
      />

      <FormattedTag
        className="game-tags-item-label text-white"
        id={`game-tags.title.${tagName}`}
      />
    </RouteLink>
  );
};

GameTagsItemUI.propTypes = {
  tagName: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  pixelRatio: PropTypes.string.isRequired,
};

export const GameTagsItem = withPixelRatio(GameTagsItemUI);
